import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);
        this.timezonesNames = this.moment.tz.names();

        super.getAreasConfigList().then(areasResp => {
            this.areas = areasResp;

            super.getOutputsConfigList()
                .then(outputsResp => {
                    this.outputs = outputsResp;
                    // this.currentTriggerObj = {};
                    this.$scope.currentPromise = null;
                    this.defaultActionText = this.gettext('Action');
                    this.currentTrigger = this.gettext('Trigger');
                    this.currentDefaultTimezone = MomentTimeZone.tz.guess();
                    this.$scope.hstep = 1;
                    this.$scope.mstep = 1;
                    var maxTime = new Date();
                    maxTime.setHours(23);
                    maxTime.setMinutes(60);
                    this.$scope.max = maxTime;
                    this.humanizeActions = {
                        area__arm: this.gettext('Arm'),
                        area__stayarm: this.gettext('Stay arm'),
                        area__disarm: this.gettext('Disarm'),
                        output__on: this.gettext('Turn ON output'),
                        output__off: this.gettext('Turn OFF output'),
                    };
                    this.SECHEDULER_ACTIONS = [
                        {
                            name: 'areas',
                            actions: ['area__arm', 'area__stayarm', 'area__disarm'],
                            isActionObjArrayExist: !_.isEmpty(this.areas),
                        },
                        {
                            name: "outputs",
                            actions: ['output__on', 'output__off'],
                            isActionObjArrayExist: !_.isEmpty(this.outputs)
                        },
                    ];
                    /*this.SECHEDULER_TRIGGERS = [
                        {name: this.gettext("Time"), actions: null},
                        {name: "Output", actions: ['output__turnon', 'output__turnoff']}
                    ];*/
                    this.indexToDaysString = {
                        0: this.gettext('Sunday'),
                        1: this.gettext('Monday'),
                        2: this.gettext('Tuesday'),
                        3: this.gettext('Wednesday'),
                        4: this.gettext('Thursday'),
                        5: this.gettext('Friday'),
                        6: this.gettext('Saturday')
                    };

                    this.setTasks();
                })
        });
    }

    getUpdatedTimeByTimezone(time, timezone) {
        let currentTime = this.moment.tz(time, timezone);
        return currentTime.format('HH:mm');
    }

    setCurrentTimezone(timezone) {
        this.currentTaskObj.timezone = angular.copy(timezone);
    }

    getNames(taskParams) {

        if (taskParams) {
            let names = [];
            let currentNameObj = null;
            let currentParamKey = _.keys(taskParams);

            for (let key of currentParamKey) {
                if (key == 'output_ids') {
                    for (let id of taskParams[key]) {
                        currentNameObj = this.getOutputById(id);
                    }
                }
                else if (key == 'area_ids') {
                    for (let id of taskParams[key]) {
                        currentNameObj = this.getAreaById(id);
                    }
                }
                if (currentNameObj) {
                    names.push(currentNameObj.name);
                }
            }

            return names.join(', ');
        }

    }

    getAreaById(areaId) {

        return _.find(this.areas, {id: areaId})
    }

    getOutputById(outputId) {

        return _.find(this.outputs, {id: outputId})
    }

    getPartialTime(hour, minute) {
        return _.padStart(hour, 2, '0') + ':' + _.padStart(minute, 2, '0');
    }

    getDaysString(daysArray) {
        let daysString = [];

        _.forEach(daysArray, (day) => {
            daysString.push(this.getTranslatableText(this.indexToDaysString[day]));
        });

        return daysString.join(', ');
    }

    /*setCurrentTrigger(triggerObj, trigger) {
        this.currentTriggerObj = triggerObj;
        this.currentTrigger = trigger;
    }*/

    setCurrentAction(action) {
        this.currentTaskObj.action = action;
        this.currentTaskObj.days_of_week = {};
        this.currentTaskObj.params = {};
    }

    setTasks() {
        this.$scope.currentPromise = this._PanelsService.getScheduledTasksList(this.panelId).then(resp => {
            this.tasks = resp.data.results;
        });
    }

    addScheduledTask(daysOfWeek, hour, minute, action, params) {
        return this._PanelsService.addScheduledTask(this.panelId, this.currentTaskObj.timezone, daysOfWeek, hour, minute, action, params);
    }

    editScheduledTask(taskId, daysOfWeek, hour, minute, action, params, disabled) {
        return this._PanelsService.editScheduledTask(this.panelId, taskId, this.currentTaskObj.timezone, daysOfWeek, hour, minute, action, params, disabled);
    }

    getScheduledTask(taskId) {
        return this._PanelsService.getScheduledTask(this.panelId, taskId);
    }

    _genericResponseHandle(func) {

        this.ModalDialogService.isModalClosed = false;

        this.$scope.currentPromise = func.then(() => {

            this.ModalDialogService.isModalClosed = true;
            this.popMessage(this.updateOKText);
        }).catch(err => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(this.errorText, 'error');
        }).finally(setTimeout(this.setTasks.bind(this), 500));

    }

    validateAtLeastOneElementHasBeenChosen(key, obj) {

        if (!this.isArrayOfObjectFalsy(angular.copy(obj))) {
            obj[key] = true;
        }
    }

    isArrayOfObjectFalsy(objs) {
        return !_.every(_.values(angular.copy(objs)), (value) => {
            return !value;
        })
    }

    mapArrayToKeyIndexObject(list) {

        let obj = {};

        _.forEach(_.values(angular.copy(list)), (param) => {

            obj[param] = true;
        });

        return obj;
    }

    mapKeyIndexObjectToNumberArray(obj) {

        let list = [];

        _.forIn(angular.copy(obj), (value, key) => {
            if (obj[key]) {
                list.push(Number(key));
            }
        });

        return list;
    }

    parseDaysOfWeek() {
        this.currentTaskObj.days_of_week = _.keys(_.pickBy(this.currentTaskObj.days_of_week, val => val !== false));
    }

    parseParams() {
        this.currentTaskObj.params[this.currentParamKey] = this.mapKeyIndexObjectToNumberArray(this.currentTaskObj.params[this.currentParamKey]);
    }

    parseBeforeSendsToSever() {
        this.parseDaysOfWeek();
        this.parseParams();
    }

    onAddTask() {
        this.currentParamKey = _.keys(this.currentTaskObj.params)[0];
        this.parseBeforeSendsToSever();
        this._genericResponseHandle(this.addScheduledTask(this.currentTaskObj.days_of_week, this.currentTaskTime.getHours(),
            this.currentTaskTime.getMinutes(), this.currentTaskObj.action, this.currentTaskObj.params))
    }

    onUpdateTask() {

        this.parseBeforeSendsToSever();

        this._genericResponseHandle(this.editScheduledTask(this.currentTaskObj.id, this.currentTaskObj.days_of_week, this.currentTaskTime.getHours(),
            this.currentTaskTime.getMinutes(), this.currentTaskObj.action, this.currentTaskObj.params, this.currentTaskObj.disabled));
    }

    onDisableEnableTask(task) {
        this.currentTaskObj = task;
        this._genericResponseHandle(this.editScheduledTask(task.id, task.days_of_week, task.hour,
            task.minute, task.action, task.params, !task.disabled));
    }

    onEditAddTask(task, requestType, index = null) {
        this.requestType = requestType;
        if (this.requestType == 'update') {
            this.getScheduledTask(task.id).then(resp => {
                this.currentTaskObjHumanizeId = index + 1;
                this.currentTaskObj = resp.data;
                this.currentTaskObj.days_of_week = this.mapArrayToKeyIndexObject(this.currentTaskObj.days_of_week);

                if (this.currentTaskObj.params.hasOwnProperty('area_ids')) {
                    this.currentParamKey = 'area_ids';
                }
                if (this.currentTaskObj.params.hasOwnProperty('output_ids')) {
                    this.currentParamKey = 'output_ids';
                }
                if (this.currentParamKey) {
                    this.currentTaskObj.params[this.currentParamKey] = this.mapArrayToKeyIndexObject(this.currentTaskObj.params[this.currentParamKey]);
                }

                this.currentTaskTime = new Date();
                this.currentTaskTime.setHours(this.currentTaskObj.hour);
                this.currentTaskTime.setMinutes(this.currentTaskObj.minute);
                this.showModal('editTaskModal');
            })
        }
        else if (this.requestType == 'add') {
            this.currentTaskObj = {};
            this.currentTaskObj.action = this.defaultActionText;
            this.currentTaskObj.timezone = this.currentDefaultTimezone;
            this.showModal('editTaskModal');
        }
    }

    onDeleteTask(index, taskId) {
        this.currentTaskId = taskId;
        this.currentTaskObjHumanizeId = index + 1;
        this.showModal('deleteTaskModal');
    }

    deleteScheduledTask(taskId) {

        this._genericResponseHandle(this._PanelsService.deleteScheduledTask(this.panelId, taskId));
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/scheduler.component/controller.js
 **/